const INSTALLATION_ID_KEY = "lapstr:push-installation-id";

function createInstallationId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `lapstr-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function getOrCreateInstallationId() {
  if (typeof window === "undefined") return null;
  try {
    const existing = window.localStorage.getItem(INSTALLATION_ID_KEY);
    if (existing) return existing;
    const next = createInstallationId();
    window.localStorage.setItem(INSTALLATION_ID_KEY, next);
    return next;
  } catch {
    return null;
  }
}
